export const brandKeyFactory = {
  all: [{ scope: 'brand' }] as const,
  list: (groupName?: string) =>
    [{ ...brandKeyFactory.all[0], entity: 'list', groupName }] as const,
}
